'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react/react.js
// module id = 300
// module chunks = 0 3 5